import React, { memo } from "react";
import DocumentMC from "./DocumentMC";

// Memoized replied document message component
export const RepliedDocumentMessageMC = memo(({ conversation, message }) => (
  <DocumentMC
    data={message}
    platform={conversation.platform}
    fileName={message.fileName}
  />
));

RepliedDocumentMessageMC.displayName = "RepliedDocumentMessageMC";

export default RepliedDocumentMessageMC;
